module.exports = __webpack_public_path__ + "static/media/og-image.6ded0225.jpg";